import { render, staticRenderFns } from "./PackageInformation.vue?vue&type=template&id=3960fab6&scoped=true"
import script from "./PackageInformation.vue?vue&type=script&lang=js"
export * from "./PackageInformation.vue?vue&type=script&lang=js"
import style0 from "./PackageInformation.vue?vue&type=style&index=0&id=3960fab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960fab6",
  null
  
)

export default component.exports